import { getQuery } from 'utils';

function createRefundOrderNumber() {
    const sequence = getQuery('sequence');
    const srmsNo = getQuery('srmsNo');
    return `退货单-${sequence || (srmsNo ? srmsNo.split('_')[0] : '')}`;
}
export default {
    'purchase/list': [['采购管理'], ['采购单列表']],
    'purchase/detail': [['采购单列表', '/purchase/list.html'], [`采购单-${getQuery('id')}`]],
    'refund/list': [['采购管理'], ['退货单列表']],
    'refund/detail': [['退货单列表', '/refund/list.html'], [`退货单-${createRefundOrderNumber()}`]],
    'contract/list': [['电子合同'], ['合同列表']],
    'contract/company': [['电子合同'], ['商户认证']],
    'info/base': [['供应商信息'], ['基本信息']],
    'info/password': [['供应商信息'], ['修改密码']],
    'info/phone': [['供应商信息'], ['换绑手机']],
    report: [['廉正举报']],
};
